var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "0 0 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7ABCF443-157B-4CA3-83B2-07DD4852EFDB@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schools/Web-Player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schools/Lessons/Player",
    transform: "translate(-582.000000, -686.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(582.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,0 C39.5832611,0 51,11.4167389 51,25.5 C51,39.5832611 39.5832611,51 25.5,51 C11.4167389,51 0,39.5832611 0,25.5 C0,11.4167389 11.4167389,0 25.5,0 Z M20.7554348,14.3022516 C19.6508653,14.3022516 18.7554348,15.1976821 18.7554348,16.3022516 L18.7554348,16.3022516 L18.7554348,34.6977484 C18.7554348,35.0925984 18.8723108,35.4786138 19.0913342,35.8071488 C19.7040391,36.7262062 20.9457778,36.9745539 21.8648352,36.361849 L21.8648352,36.361849 L35.6614578,27.1641006 C35.8811624,27.0176309 36.0696883,26.829105 36.216158,26.6094004 C36.8288629,25.690343 36.5805152,24.4486043 35.6614578,23.8358994 L35.6614578,23.8358994 L21.8648352,14.638151 C21.5363001,14.4191276 21.1502848,14.3022516 20.7554348,14.3022516 Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay15X);
export default __webpack_public_path__ + "static/media/Play@1.5x.baa5908f15c4fbf0194e057adb0d1183.svg";
export { ForwardRef as ReactComponent };